import styled from 'styled-components';
import ReactModal from 'react-modal';
import { colors } from '../../../theme/styled';
import { CloseButton as CloseButtonComponent } from '../../closeButton';


export const Container = styled(ReactModal)``;

export const Content = styled.div``;

export const CloseButton = styled(CloseButtonComponent)`
  position: absolute;
  top: 35px;
  right: 30px;
  background-color: ${colors.yellow};

  &:hover {
    background-color: ${colors.accessibilityYellow};
  }
`;
